import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import Return from '@app/model/_common/Return';
import {
	CompanyHotelIntegrations,
	Integration,
	IntegrationRunsPage,
    IntegrationRoomRefreshResult,
	SaveIntegrationInput,
} from '@app/model/integration-settings/Integration';
import {
	FIND_COMPANY_HOTEL_INTEGRATIONS_QUERY,
	FIND_COMPANY_INTEGRATIONS_QUERY,
	FIND_INTEGRATION_RUNS_QUERY,
	RUN_INTEGRATION_BACKFILL_MUTATION,
    REFRESH_INTEGRATION_ROOMS_MUTATION,
	SAVE_INTEGRATION_MUTATION,
	SET_INTEGRATION_ENABLED_MUTATION,
	TEST_INTEGRATION_CONNECTION_MUTATION,
} from '@app/model/integration-settings/service/IntegrationSettingsGraphQLQueries';

class IntegrationSettingsService {
    public static refreshIntegrationRooms(integrationId: number) {
        return GraphQLExecutor.execute<IntegrationRoomRefreshResult>(REFRESH_INTEGRATION_ROOMS_MUTATION, { integrationId });
    }

	public static findCompanyIntegrations() {
		return GraphQLExecutor.execute<CompanyHotelIntegrations[]>(FIND_COMPANY_INTEGRATIONS_QUERY, {});
	}

	public static findCompanyHotelIntegrations(companyHotelId: number) {
		return GraphQLExecutor.execute<CompanyHotelIntegrations>(FIND_COMPANY_HOTEL_INTEGRATIONS_QUERY, { companyHotelId });
	}

	public static findIntegrationRuns(integrationId: number) {
		return GraphQLExecutor.execute<IntegrationRunsPage>(FIND_INTEGRATION_RUNS_QUERY, { integrationId });
	}

	public static saveIntegration(input: SaveIntegrationInput) {
		return GraphQLExecutor.execute<Integration>(SAVE_INTEGRATION_MUTATION, { input });
	}

	public static testIntegrationConnection(input: SaveIntegrationInput) {
		return GraphQLExecutor.execute<Return>(TEST_INTEGRATION_CONNECTION_MUTATION, { input });
	}

	public static setIntegrationEnabled(variables: { integrationId: number, enabled: boolean }) {
		return GraphQLExecutor.execute<Integration>(SET_INTEGRATION_ENABLED_MUTATION, variables);
	}

	public static runIntegrationBackfill(integrationId: number) {
		return GraphQLExecutor.execute<Integration>(RUN_INTEGRATION_BACKFILL_MUTATION, { integrationId });
	}
}

export default IntegrationSettingsService;
